<template lang="pug">
  section.looper
    router-link.article-link(:to="article.slug" v-for="(article, index) in articles" :key="index")
      ArticleItem(:title="article.title", :undertitle="article.undertitle", :beforetitle="article.beforetitle",
      :aftertitle="article.aftertitle", :img="article.img", :more="true", :alignment="article.alignment", :video="article.video")
</template>
<script>
import ArticleItem from '@/components/ArticleItem'

export default {
  props: {
    articles: Array
  },
  components: {
    ArticleItem
  }
}

</script>



